/* eslint-disable no-sparse-arrays */
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import { useDispatch, useSelector } from "react-redux";
import { usePagination, useRowSelect, useSortBy, useTable } from "react-table";
import iconAction from "../../../assets/images/icon-action.png";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useHistory } from "react-router-dom";
import iconFile from "../../../assets/images/icon-file-active.svg";
import iconFileDesactive from "../../../assets/images/icon-file-desactive.svg";
import Alert from "../../../components/Alert/Alert";
import Avatar from "@mui/material/Avatar";
import iconPdf from "../../../assets/images/pdf-non-active.png";
import iconUpdate from "../../../assets/images/update-pen.svg";
import iconUpdateActif from "../../../assets/images/update-pen-active.svg";
import RingLoaderShared from "../../../shared/RingLoader/RingLoader";
import {
  allCalibsWithFilter,
  getCalibsByTenantId,
  getMesCalibs,
  getMesCalibsWithFilter,
  deactivateCalib,
  getOneCalibrage,
} from "../../../redux/actions/calibrage";
import { Tooltip as MuiTooltip } from "@mui/material";
import { statusStyles } from "./shared";
import DialogAlert from "../../../shared/DialogAlertModal/DialogAlert";
import iconBlockedActive from "../../../assets/images/noun-blocked-active.png";
import iconBlocked from "../../../assets/images/BlockIcon.png";
import calendarIcon from "../../../assets/images/calendarIcon.svg";
const CalibrageList = (props) => {
  const reloadClibList = props.reloadClibList;
  const { isOpen, prevPage, statusList } = useSelector((state) => state.design);
  const { message, status } = useSelector((state) => state.message);
  const { datacalibs } = useSelector((state) => state.calibrage);
  const { datacalib } = useSelector((state) => state.calibrage);
  const hisotry = useHistory();
  const [count, setCount] = useState(0);
  const [pageI, setPageI] = useState(0);
  const [duplicate, setDuplicate] = useState(props.duplicate);
  const [display, setDisplay] = useState("none");
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const [selectedId, setSelectedId] = useState(null);
  const user_auth0 = JSON.parse(localStorage.getItem("user_auth0"));
  let isHome = window.location.pathname === "/home";
  let isQualtyMonotoring = window.location.pathname === "/quality-monitoring";
  const pdfExportComponent = React.useRef(null);
  const [open, setOpen] = useState(false);
  const [errorMessageEdit, setErrorMessageEdit] = useState(null);
  const [showspinner, setShowspinner] = useState(true);
  const [displayAlertAnnuleCalib, setDisplayAlertAnnulercalib] =
    useState(false);
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };
  const handleClose = (confirm) => {
    setOpen(false);
    if (confirm) {
      deactivate();
    }
  };

  const handleShow = () => setOpen(true);

  function isUserInCalibrage(calibrageId) {
    const calibrage = datacalibs.calibrages.find(
      (calibrage) => calibrage.id === calibrageId
    );

    const isInEvaluations = calibrage.evaluations?.some(
      (evaluation) => evaluation.evaluateurId === user.id
    );

    const isInParticipants = calibrage.participants?.some(
      (participant) => participant.id === user.id
    );
    if (!isInParticipants && calibrage.createdBy === user.id) {
      return true;
    }

    return isInEvaluations && isInParticipants;
  }
  function isAdminOfCalibrage(calibrageId) {
    const calibrage = datacalibs.calibrages.find(
      (calibrage) => calibrage.id === calibrageId
    );
    const isInEvaluations = calibrage.evaluations?.some(
      (evaluation) => evaluation.evaluateurId === user.id
    );
    const isInParticipants = calibrage.participants?.some(
      (participant) => participant.id === user.id
    );
    if (
      user_auth0["http://role.tn/roles"][0] === "ADMIN" &&
      calibrage.TenantId === user.TenantId &&
      !isInParticipants &&
      calibrage.createdBy != user.id
    ) {
      return true;
    }
  }

  useEffect(() => {
    setShowspinner(true);
    setDuplicate(props.duplicate);
    setCount(0);
    fetchdataCalibs(0, pageSize);
  }, [dispatch, statusList, reloadClibList]);

  localStorage.setItem("createdBy", datacalib?.CreatedBy);
  const fetchdataCalibs = (pageI, size) => {
    setShowspinner(true);
    if (statusList.length <= 0) {
      user_auth0["http://role.tn/roles"][0] === "MANAGER"
        ? dispatch(getMesCalibs(pageI, size))
            .then((res) => {
              setShowspinner(false);
            })
            .catch((err) => {
              console.log("err", err);
            })
        : user_auth0["http://role.tn/roles"][0] === "ADMIN"
        ? dispatch(getCalibsByTenantId(pageI, size))
            .then((res) => {
              setShowspinner(false);
            })
            .catch((err) => {
              console.log("err", err);
            })
        : null;
      setShowspinner(false);
    } else {
      user_auth0["http://role.tn/roles"][0] === "MANAGER"
        ? dispatch(getMesCalibsWithFilter(pageI, size, statusList))
            .then((res) => {
              setShowspinner(false);
            })
            .catch((err) => {
              console.log("err", err);
            })
        : dispatch(allCalibsWithFilter(pageI, size, statusList))
            .then((res) => {
              setShowspinner(false);
            })
            .catch((err) => {
              console.log("err", err);
            });

      props.setChecked(true);
    }
  };

  const onDisplay = (display) => {
    setDisplay(display);
  };

  const deactivate = () => {
    dispatch(deactivateCalib(selectedId))
      .then(() => {
        setTimeout(() => {
          fetchdataCalibs(0, 10);
          setDisplay("block");
          setDisplayAlertAnnulercalib(true);
        }, 3000);
        setDisplay("block");
        document.getElementById("tooltip-bottom-action").style.display = "none";
      })
      .catch(() => {});
    setTimeout(() => {
      setDisplay("none");
      setDisplayAlertAnnulercalib(false);
    }, 3000);
  };

  const popover = (haspermission, duplicate, props) => (
    <Tooltip id="tooltip-bottom-action" style={{ opacity: 1, width: "240px" }}>
      <div className="row">
        <div className="col-3 align-it">
          <OverlayTrigger
            key="bottom"
            placement="bottom"
            overlay={
              <Tooltip data-color="#5800e2" id="tooltip-bottom1">
                enregister PDF
              </Tooltip>
            }
          >
            <div id="cercle-tooltip-action">
              <img
                alt=""
                src={iconPdf}
                width="22"
                height="22"
                onClick={() => alert(props.data[props.row.id].status)}
                onMouseOut={(e) => (e.currentTarget.src = iconPdf)}
              />
            </div>
          </OverlayTrigger>
        </div>

        {(() => {
          const status = props.data[props.row.id].status;
          const isDisabled =
            JSON.parse(localStorage.getItem("user"))?.id !=
              localStorage.getItem("createdBy") ||
            ["Pret", "Termine", "Annule"].includes(status) ||
            haspermission;
          const handleMouseOverModifier = (e) =>
            (e.currentTarget.src = iconUpdateActif);
          const handleMouseOutModifier = (e) =>
            (e.currentTarget.src = iconUpdate);

          const handleMouseOverAnnuler = (e) =>
            (e.currentTarget.src = iconBlockedActive);
          const handleMouseOutAnnuler = (e) =>
            (e.currentTarget.src = iconBlocked);
          return (
            <>
              <div className="col-3 align-it">
                <OverlayTrigger
                  key="bottom"
                  placement="bottom"
                  overlay={
                    <Tooltip data-color="#5800e2" id={`tooltip-bottom1`}>
                      Modifier
                    </Tooltip>
                  }
                >
                  <div
                    id={
                      isDisabled
                        ? "cercle-tooltip-action-disabled"
                        : "cercle-tooltip-action"
                    }
                    style={isDisabled ? { cursor: "not-allowed" } : {}}
                    onClick={!isDisabled ? openUpdateCalibrage : undefined}
                  >
                    <img
                      alt="Modifier"
                      src={iconUpdate}
                      onMouseOver={handleMouseOverModifier}
                      onMouseOut={handleMouseOutModifier}
                      width="22"
                      height="22"
                      style={isDisabled ? { filter: "blur(1px)" } : {}}
                    />
                  </div>
                </OverlayTrigger>
              </div>

              <div className="col-3 align-it">
                <OverlayTrigger
                  key="bottom"
                  placement="bottom"
                  overlay={
                    <Tooltip data-color="#5800e2" id={`tooltip-bottom1`}>
                      Annuler
                    </Tooltip>
                  }
                >
                  <div
                    id={
                      isDisabled
                        ? "cercle-tooltip-action-disabled"
                        : "cercle-tooltip-action"
                    }
                    style={isDisabled ? { cursor: "not-allowed" } : {}}
                    onClick={!isDisabled ? handleShow : undefined}
                  >
                    <img
                      alt="Annuler"
                      src={iconBlocked}
                      onMouseOver={handleMouseOverAnnuler}
                      onMouseOut={handleMouseOutAnnuler}
                      width="20"
                      height="20"
                      style={isDisabled ? { filter: "blur(1px)" } : {}}
                    />
                  </div>
                </OverlayTrigger>
              </div>
            </>
          );
        })()}
      </div>
    </Tooltip>
  );

  function format(inputDate) {
    let date, month, year;

    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();

    date = date.toString().padStart(2, "0");

    month = month.toString().padStart(2, "0");

    return `${date}/${month}/${year}`;
  }

  function openUpdateCalibrage() {
    props.setUpdateOpenCallibrage(true);
  }

  function setConcernedCalibId(id) {
    props.handleConcernedCalibId(id);
  }
  const columns = React.useMemo(
    () => [
      {
        Header: "Identifiant",
        accessor: "id",
        width:'13%',
        Cell: (props) => {
          const status = props.data?.[props.row.id]?.status;
          return (
            <OverlayTrigger key="bottom" placement="bottom" overlay={<></>}>
              <div
                onClick={() => {
                  const status = props.data[props.row.id].status;

                  if (
                    isUserInCalibrage(props.value) &&
                    status !== "Annule" &&
                    status !== "Echu"
                  ) {
                    hisotry.push(`/calibrage-en-cours?id=${props.value}`);
                  } else if (
                    isAdminOfCalibrage(props.value) ||
                    status === "Annule" ||
                    status === "Echu"
                  ) {
                    hisotry.push(`/details-calibrage?id=${props.value}`);
                  } else {
                    hisotry.push(`/add-eval-calib?id=${props.value}`);
                  }
                }}
                style={{ cursor: "pointer", opacity: 1 }}
              >
                <span className="badge-style-qm" pill>
                  {props.value}
                </span>
              </div>
            </OverlayTrigger>
          );
        },
      },

      {
        Header: "Date de création",
        accessor: "date",
        id: "date",
        width:'18%',
        Cell: (props) => {
          let isCreate =
            Date.parse(props?.cell?.row?.original?.createdAt) ===
            Date.parse(props?.cell?.row?.original?.updatedAt);

          return (
            <div style={{ fontSize: 12, textAlign: "left" }}>
              <div className="flex-box">
                <span
                  style={{ fontSize: "15.5px", fontWeight: "Gilroy-Regular" }}
                >
                  {isCreate
                    ? `Créée par: ${
                        props.cell.row.original?.creator?.firstName +
                        " " +
                        props.cell.row.original?.creator?.lastName
                      }`
                    : `Modifié par: ${
                        props.cell.row.original?.creator?.firstName +
                        " " +
                        props.cell.row.original?.creator?.lastName
                      }`}
                </span>
              </div>
              <div style={{ display: "flex", color: "#4C434E" }}>
                <img width={14} src={calendarIcon} />{" "}
                <span style={{ fontSize: 12, marginLeft: "0.7rem" }}>
                  {isCreate
                    ? format(new Date(props?.cell?.row?.original?.createdAt))
                    : format(new Date(props?.cell?.row?.original?.updatedAt))}
                </span>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Grille",
        accessor: "grid.name",
        width:'14%',
        Cell: (props) => {
          return (
            <div
              className="evaluator"
              style={{
                marginTop: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 10,
                width: "100px",
              }}
            >
              <div className="evaluator-spans">
                <span style={{ color: "#000", textAlign: "left" }}>
                  {" "}
                  {props?.value}{" "}
                </span>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Évalué",
        accessor: "agent",
        width:'15%',
        Cell: (props) => {
          return (
            <div className="flex-box">
              <div>
                <Avatar
                  className="borderedImg"
                  alt={props?.value?.firstName}
                  sx={{ bgcolor: "#5700E2", width: "30px", height: "30px" }}
                >
                  {props?.value?.firstName.charAt(0).toUpperCase() +
                    props?.value?.lastName.charAt(0).toUpperCase()}
                </Avatar>
              </div>
              <span className="roundedImg-name" style={{ marginLeft: "8px" }}>
                {props?.value?.firstName} {props?.value?.lastName}
              </span>
            </div>
          );
        },
      },

      {
        Header: "Date d’évaluation",
        accessor: "dateLimite",
        width:'14%',
        Cell: (props) => {
          return (
            <div style={{ marginTop: "4px", textAlign: "start" }}>
              <img height={isHome ? 10 : 15} src={calendarIcon} />
              <span style={{ padding: "10px" }}>
                {format(new Date(props.value))}
              </span>
            </div>
          );
        },
      },
      {
        Header: "Évaluateurs",
        accessor: "participants",
        width:'9%',
        Cell: (props) => {
          const {
            createdBy,
            creator,
            value: participants,
          } = props.row.original; // Access createdBy and participants from the row data

          return (
            <div>
              <div
                className="evaluator flex-box"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <div>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {props?.value?.map((user, index) => (
                      <MuiTooltip
                        title={`${
                          user?.firstName
                            ? capitalizeFirstLetter(user.firstName)
                            : ""
                        } 
                          ${
                            user?.lastName
                              ? capitalizeFirstLetter(user.lastName)
                              : ""
                          }`}
                        arrow
                        key={index}
                      >
                        <Avatar
                          alt={user.firstName}
                          sx={{
                            bgcolor:
                              user.id === creator?.id ? "#000" : "#5800E2",
                            border:
                              user.id === creator?.id
                                ? "2px solid #000"
                                : "2px solid transparent",
                            width: "30px",
                            height: "30px",
                          }}
                          className="borderedImg"
                        >
                          {user.firstName.charAt(0).toUpperCase() +
                            user.lastName.charAt(0).toUpperCase()}
                        </Avatar>
                      </MuiTooltip>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        width:'17%',
        Cell: (props) => {
          const status = statusStyles[props.value];
          if (!status) return null;
          return (
            <div
              style={{
                margin: "auto",
                borderRadius: "41px",
                width: "119px",
                height: "42px",
                padding: "5px",
                paddingTop: "11px",
                backgroundColor: status.backgroundColor,
                color: status.color,
                textAlign:"justify"
              }}
            >
              <img
                src={status.icon}
                alt="Status Icon"
                style={{ marginRight: "4px",marginLeft:'9px',height:'16px',width:'16px' }}
              />

              {(() => {
                switch (props.value) {
                  case "Echu":
                    return "Échu";
                  case "Annule":
                    return "Annulé";
                  case "ARealiser":
                    return "À réaliser";
                  case "EnCours":
                    return "À finaliser";
                  case "Pret":
                    return "À calibrer";
                  case "Termine":
                    return "Terminé";
                  default:
                    return "";
                }
              })()}
            </div>
          );
        },
      },
      ,
      {
        Header: "Action",
        accessor: "action",
        width:'17%',
        Cell: (props) => {
          const status = props.data[props.row.id].status;

          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <img
                width={isHome ? 20 : 40}
                height={isHome ? 20 : 40}
                style={{
                  cursor: status === "Termine" && "pointer",
                  backgroundColor:
                    status === "Termine" ? "transparent" : "#fffff0",
                }}
                src={status === "Termine" ? iconFile : iconFileDesactive}
                onClick={() => {
                  if (status === "Termine") {
                    hisotry.push(
                      `/calibrage-en-cours?id=${props.data[props.row.id].id}`
                    );
                  }
                }}
              />
              <OverlayTrigger
                trigger="click"
                placement="bottom-end"
                rootClose
                overlay={popover(props.haspermission, duplicate, props)}
              >
                <img
                  height={isHome ? 20 : 40}
                  style={{ cursor: "pointer" }}
                  src={iconAction}
                  onClick={() => {
                    dispatch(getOneCalibrage(props.data[props.row.id].id));

                    setSelectedId(props.data[props.row.id].id);
                    setConcernedCalibId(props.data[props.row.id].id);
                    selectedStatus = props.data[props.row.id].status;
                  }}
                />
              </OverlayTrigger>
            </div>
          );
        },
      },
    ],
    [datacalibs]
  );

  const getVisiblePages = (page, total) => {
    if (total < 7) {
      return filterPages([1, 2, 3, 4, 5, 6], total);
    } else {
      if (page % 5 >= 0 && page > 4 && page + 2 < total) {
        return [1, page - 1, page, page + 1, total];
      } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total];
      } else {
        return [1, 2, 3, 4, 5, total];
      }
    }
  };

  const filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter((page) => page <= totalPages);
  };

  const tableInstance = useTable(
    {
      columns,
      data: datacalibs?.calibrages,
      initialState: { pageIndex: 0, pageSize: isHome ? 3 : 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",

          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),

          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox
                {...row.getToggleRowSelectedProps()}
                row={row}
              />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,

    setPageSize,
    state: { pageSize, selectedRowIds },
  } = tableInstance;

  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;

      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate, selectedRowIds, count]);

      return (
        <div style={{ marginLeft: "15px" }}>
          <label className="container-checkbox">
            <input type="checkbox" ref={resolvedRef} {...rest} />
            <span
              className="checkmark"
              style={isHome ? { height: 15, width: 15 } : null}
            ></span>
          </label>
        </div>
      );
    }
  );
  return datacalibs.totalItems === 0 ? (
    <div className="container-add-groupe-critere">
      <span className="add-grid_btn-title">Aucun calibrage réalisé</span>
    </div>
  ) : !showspinner ? (
    <div
      className={clsx({
        "font-table-home table-resp": isHome,
        ["font-table-quality-monotoring table-full"]: isQualtyMonotoring,
        ["font-table-quality-monotoring-animated"]:
          isOpen && isQualtyMonotoring && prevPage === "home",
        table: true,
      })}
      style={{ minHeight: "406px" }}
    >
      <BTable
        striped
        bordered
        hover
        size="sm"
        {...getTableProps()}
        id="borderless-cell"
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <>
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    style={{
                      textAlign: ["Identifiant", "Status", "Action"].includes(
                        column.render("Header")
                      )
                        ? "center"
                        : "left",
                        width: column.width,
                    }}
                  >
                    {
                      <>
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? "↑"
                              : "↓"
                            : ""}
                        </span>
                      </>
                    }
                  </th>
                </>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);

            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      style={{ textAlign: "center",width: cell.column.width, }}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>

      <div className="pagnation" style={isHome ? { marginTop: "-10px" } : null}>
        <div className="buttonP">
          <button
            className={clsx({
              "pagination-chevron-disabled": !(datacalibs?.currentPage > 0),
              ["pagination-chevron"]: datacalibs?.currentPage > 0,
              "button-height-width-22px": isHome,
            })}
            onClick={() => {
              setPageI(pageI - 1);
              fetchdataCalibs(pageI - 1, pageSize);
            }}
            disabled={!(datacalibs?.currentPage > 0)}
          >
            <i className="fa fa-chevron-left"></i>
          </button>
        </div>
        {getVisiblePages(datacalibs?.currentPage, datacalibs?.totalPages).map(
          (page, index, array) => {
            return (
              <button
                className={clsx({
                  activeP: datacalibs?.currentPage + 1 === page,
                  ["btnP"]: true,
                  "button-height-width-22px": isHome,
                })}
                onClick={() => {
                  setPageI(page - 1);
                  fetchdataCalibs(page - 1, pageSize);
                }}
                key={page}
              >
                {page}
              </button>
            );
          }
        )}
        <div className="buttonP">
          <button
            className={clsx({
              "pagination-chevron-disabled": !(
                datacalibs?.currentPage + 1 <
                datacalibs?.totalPages
              ),
              ["pagination-chevron"]:
                datacalibs?.currentPage + 1 < datacalibs?.totalPages,
              "button-height-width-22px": isHome,
            })}
            onClick={() => {
              setPageI(pageI + 1);
              fetchdataCalibs(pageI + 1, pageSize);
            }}
            disabled={datacalibs?.currentPage + 1 === datacalibs?.totalPages}
          >
            <i className="fa fa-chevron-right"></i>
          </button>
        </div>
        <select
          className={clsx({
            "select-pagination": true,
            "select-height-width-22px": isHome,
          })}
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setPageI(0);
            fetchdataCalibs(0, Number(e.target.value));
            getVisiblePages(0, datacalibs?.totalPages);
          }}
        >
          {[isHome ? 3 : 5, 10, 15].map((pageSize) => (
            <option
              style={{ textAlignLast: "center" }}
              key={pageSize}
              value={pageSize}
            >
              {pageSize}
            </option>
          ))}
        </select>
      </div>
      {message && status === "error" && (
        <Alert
          message={message}
          status={"danger"}
          display={display}
          onDisplay={onDisplay}
        />
      )}

      {errorMessageEdit ? (
        <Alert
          message={errorMessageEdit}
          status={"warning"}
          display={display}
          onDisplay={onDisplay}
        />
      ) : null}

      <div
        style={{
          position: "absolute",
          left: "-1000px",
          top: 0,
        }}
      >
        <PDFExport
          paperSize={"A4"}
          fileName={"test"}
          scale={0.8}
          margin="0cm"
          title=""
          subject=""
          keywords=""
          ref={pdfExportComponent}
          forcePageBreak=".chapter"
        >
          <div
            style={{
              height: "800vh",
              width: "100%",
              padding: "none",
              margin: "auto",
              overflowX: "hidden",
              overflowY: "scroll",
            }}
          ></div>
        </PDFExport>
      </div>
      <DialogAlert
        open={open}
        handleClose={handleClose}
        title={"Confirmation"}
        message={"Etes-vous sûr de vouloir annuler ce calibrage ?"}
      />
    </div>
  ) : (
    <RingLoaderShared />
  );
};

export default CalibrageList;
